import { SeverityLevel } from "@sentry/nextjs";
import { NQError, NQErrorCode } from "@visonum/network-quality-sdk";
import { NQInternalError, NQInternalErrorCode } from "@visonum/network-quality-sdk/dist/src/main/NQError";

export const errorToSeverityLevel = (error: NQError): SeverityLevel => {
    switch (error.code) {
        case NQErrorCode.Server: return "error";
        case NQErrorCode.Client: return "error";
        case NQErrorCode.Connectivity:
            if (error.cause instanceof NQInternalError) {
                switch (error.cause.internalCode) {
                    case NQInternalErrorCode.DownloadError:
                    case NQInternalErrorCode.DownloadTimeout:
                    case NQInternalErrorCode.UploadError:
                    case NQInternalErrorCode.UploadTimeout:
                        return "error";
                }
            }
            return "log";
        case NQErrorCode.SystemUnderMaintenance: return "info";
        case NQErrorCode.RateLimit: return "info";
        case NQErrorCode.ParallelSpeedtests: return "log";
    }
}

export default errorToSeverityLevel;